const InMemoryS3Credentials = {
  _data: null,
  persitCredentials: function(newCredentials) {
    this._data = { ...newCredentials };
  },
  hasBeenInvalid: function() {
    if (!this._data) return true;

    const expiredTime = this._data?.credentials?.Expiration;

    return new Date(expiredTime) <= new Date();
  },
  getCredentialData: function() {
    return this._data;
  }
};

export default InMemoryS3Credentials;
